<template>
  <div class="pa-ovl" role="dialog" aria-modal="true" aria-labelledby="pa-live-page-title" @click.self="$emit('close')">
    <!-- design pa-app.jsx onPublishOne / Modal: round add_link icon, muted body, URL box, confirm disabled until filled -->
    <div class="pa-cmodal">
      <div class="pa-cmodal__icon"><i class="material-icons" aria-hidden="true">add_link</i></div>
      <h3 id="pa-live-page-title" class="pa-cmodal__title">{{ isAdmin ? 'Add live page (admin)' : 'Add live URL' }}</h3>
      <p v-if="isAdmin" class="pa-cmodal__body">
        Paste the published URL for “{{ keyword }}”. The row switches to Published with today's date, the user gets a
        View live page link, and the URL is added to Wins tracking.
      </p>
      <p v-else class="pa-cmodal__body">
        Paste the URL where “{{ keyword }}” is published. We start measuring impressions, clicks and rankings for
        that page from the next data pull.
      </p>
      <input
        ref="url"
        v-model="url"
        class="pa-in pa-live-page__url"
        type="url"
        inputmode="url"
        placeholder="https://yoursite.com/your-new-page/"
        :disabled="busy"
        @keydown.enter.prevent="submit"
      />
      <p v-if="showError" class="pa-err pa-cmodal__err">Enter the full URL, including https://</p>
      <div class="pa-cmodal__acts">
        <button type="button" class="pa-btn pa-btn--out" :disabled="busy" @click="$emit('close')">Cancel</button>
        <!-- design Modal `textRequired`: nothing to mark until a URL is typed -->
        <button
          type="button"
          class="pa-btn pa-btn--orange"
          :disabled="busy || !url.trim()"
          @click="submit"
        >Mark published</button>
      </div>
    </div>
  </div>
</template>

<script>
/** Records an article's live URL, by the admin or (self-publish) the client. Emits `close`, and `confirm` with { liveUrl }. */
const URL_RE = /^https?:\/\/[^\s.]+\.[^\s]{2,}$/i

export default {
  name: 'PopAuthorityLivePageModal',
  props: {
    keyword: { type: String, default: '' },
    initialUrl: { type: String, default: '' },
    isAdmin: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
  },
  data () {
    return {
      url: this.initialUrl || '',
      showError: false,
    }
  },
  watch: {
    url () {
      this.showError = false
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.url) this.$refs.url.focus()
    })
  },
  methods: {
    submit () {
      const raw = (this.url || '').trim()
      if (!raw || this.busy) return
      const withScheme = !/^https?:\/\//i.test(raw) ? `https://${raw}` : raw
      if (!URL_RE.test(withScheme)) {
        this.showError = true
        return
      }
      this.$emit('confirm', { liveUrl: withScheme })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './setup/setup.scss';
@import './setup/designModal.scss';

/* the URL box sits 6px under the body text like the design's textarea */
.pa-live-page__url {
  margin-top: 6px;
}
</style>
